import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'

const useSmartwatchAPI = () => {
  const { send } = useFetchData()

  const getDevices = async (params) => {
    params = params ?? {}

    const body = await send({
      method: "GET",
      url: `${apiUrl}/smartwatch/devices`,
      params: {
        "type": params["type"],
        "search": params["search"] ?? "",
        "offset": params["offset"],
        "limit": params["limit"]
      },
      returnType: "json"
    })

    return body
  }

  const updateWorkerAssignment = async (params) => {
    params = params ?? {}

    const res = await send({
      method: "PUT",
      url: `${apiUrl}/smartwatch/assignment/${params["device_id"]}`,
      contentType: "json",
      body: {
        "worker_id": params["worker_id"]
      }
    })

    return res
  } 

  const addDevice = async (params) => {
    params = params ?? {}

    const res = await send({
      method: "POST",
      url: `${apiUrl}/smartwatch/device`,
      contentType: "json",
      body: {
        "device_id": params["device_id"],
        "device_type": params["device_type"],
        "worker_id": params["worker_id"],
      }
    })

    return res
  } 

  return { getDevices, updateWorkerAssignment, addDevice }
}

export default useSmartwatchAPI
